const menu = document.querySelector('.cirrus-mobile-menu');
const toggle = menu.querySelector('.cirrus-mobile-menu__toggle');
const content = menu.querySelector('.cirrus-mobile-menu__content');

toggle.addEventListener('click', () => {
    toggle.classList.toggle('is-active');
    menu.classList.toggle('--is-active');
    document.body.classList.toggle('noscroll');
})
